import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import {ValidationMessageComponent} from './validation-message.component';

@NgModule({
  declarations: [ValidationMessageComponent ],
  imports: [CommonModule, MatIconModule, MatAutocompleteModule ],
  exports: [ValidationMessageComponent ],
  providers: [],
})
export class ValidationMessageModule {
}
